import React from 'react'
import Schedule from './Schedule'
import Access from './Access'
import Contact from './Contact'
import Introduction from './Introduction'

class Main extends React.Component {
  render() {
    // const facilityList = [
    //   {
    //     id: 'sinden',
    //     name: '１２誘導心電図装置',
    //     image: 'pngs/sinden.jpg',
    //     introduction:
    //       'この装置では安静時１２誘導心電図、マスター負荷心電図、２４時間ホルター心電図が測定できます。不整脈や心肥大、狭心症、心筋梗塞などの診断に有効です。また、バイシクルエルゴメーターと接続して負荷時の心電図を連続して測定できるので、労作性狭心症の診断にも有用です。',
    //   },
    //   {
    //     id: 'onpa',
    //     name: '超音波断層装置',
    //     image: 'pngs/onpa.jpg',
    //     introduction:
    //       '体の表面から超音波をあてて、反射してくる音波をとらえて画像にします。魚群探知機と原理は同じですが、現在の装置では直径数ミリの病変も描出できます。心臓弁膜症、先天性心奇形、胆石症、肝臓癌、脂肪肝、腎臓結石、前立腺肥大症等の診断に有効で、現在では聴診器による診察と同じ位ポピュラーな検査になっています。',
    //   },
    //   {
    //     id: 'erugo',
    //     name: '負荷心電図用エルゴメーター',
    //     image: 'pngs/erugo.jpg',
    //     introduction:
    //       '心電図装置と接続して運動負荷時の心電図を連続的に測定します。労作性狭心症の診断の他、運動負荷時の不整脈の出現等の診断に用いますが、中高年の方でスポーツを新たに始める時の運動負荷目標をたてるのにも有用です。',
    //   },
    // ]

    return (
      <div className="main-wrapper" id="main-wrapper">
        <Introduction />
        <Schedule />
        <Access />
        <Contact />
      </div>
    )
  }
}

export default Main

